import { useEffect, useState } from "react";
import MainSection from "../Partials/MainSection";

const SLIDE_DURATION = 10000;

export default function Carousel({ slides }) {
  let [current, setCurrent] = useState(0);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (!slides?.length) {
      return undefined;
    }

    if (slides.length === 1) {
      setProgress(1);
      return undefined;
    }

    let frameId = 0;
    let timeoutId = 0;
    const startTime = performance.now();

    const updateProgress = (now) => {
      const nextProgress = Math.min((now - startTime) / SLIDE_DURATION, 1);
      setProgress(nextProgress);

      if (nextProgress < 1) {
        frameId = window.requestAnimationFrame(updateProgress);
      }
    };

    setProgress(0);
    frameId = window.requestAnimationFrame(updateProgress);
    timeoutId = window.setTimeout(() => {
      setCurrent((previous) => (previous === slides.length - 1 ? 0 : previous + 1));
    }, SLIDE_DURATION);

    return () => {
      window.cancelAnimationFrame(frameId);
      window.clearTimeout(timeoutId);
    };
  }, [current, slides]);

  const previousSlide = () => {
    if (current === 0) {
      setCurrent(slides.length - 1);
      return;
    }

    setCurrent(current - 1);
  };

  const nextSlide = () => {
    if (current === slides.length - 1) {
      setCurrent(0);
      return;
    }

    setCurrent(current + 1);
  };

  return (
    <div className="relative">
      {slides.map((s, i) => {
          return (
            i === current && <MainSection
              key={s.title}
              title={s.title}
              description={s.description}
              src={s.src}
              onPrevious={previousSlide}
              onNext={nextSlide}
            />
    
          );
        })}

      {/* <div className="absolute top-0 h-full w-full justify-between items-center flex text-white px-10 text-3xl">
        <button onClick={previousSlide}>
          <BsFillArrowLeftCircleFill />
        </button>
        <button onClick={nextSlide}>
          <BsFillArrowRightCircleFill />
        </button>
      </div> */}

      <div className="absolute left-0 top-[14.25rem] flex w-full justify-start gap-2 text-button_transition_1 md:hidden">
        <button
          type="button"
          onClick={previousSlide}
          className="flex items-center justify-start text-[3rem] leading-none"
          aria-label="Previous slide"
        >
          &#8249;
        </button>
        <button
          type="button"
          onClick={nextSlide}
          className="flex items-center justify-start text-[3rem] leading-none"
          aria-label="Next slide"
        >
          &#8250;
        </button>
      </div>

      <div className="absolute left-14 right-14 top-3 hidden justify-start 1.5md:flex 1.5xl:left-18 1.5xl:right-18 1.5xl:top-4">
        <div className="flex items-center gap-2">
          {slides.map((s, i) => (
            <button
              type="button"
              onClick={() => {
                setCurrent(i);
              }}
              key={"circle" + i}
              className={`relative h-2 w-7 overflow-hidden rounded-lg transition-colors duration-300 ${
                i === current ? "bg-[#f5c188]" : "bg-gray-200"
              }`}
              aria-label={`${i + 1}. slayta git`}
            >
              <div
                className={`absolute inset-y-0 left-0 rounded-lg transition-[width] duration-200 ${
                  i === current ? "bg-button_transition_2" : "bg-transparent"
                }`}
                style={{
                  width: i === current ? `${progress * 100}%` : '0%',
                }}
              />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
